export class DashboardModel {
    startDate :Date;
    endDate : Date;
    constructor(){
        this.startDate = null;
        this.endDate = null;
    }
}